import axios from "axios";

// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;
// const base_path = process.env.REACT_APP_API_URL;

//Get sales invoice by transaction type and branch
// from / to: optional yyyy-MM-dd (inclusive); without them every document
export const getSalesByTransType = async (branch, transType, from, to) => {
  const range =
    (from ? `&fromDate=${from}` : "") + (to ? `&toDate=${to}` : "");
  const response = axios.get(
    `${base_path}/Api/InvSale/GetAllByTransType?globalBranchID=${branch?.guid}&TransType=${transType}${range}`
  );

  return response;
};

export const deleteSales = async (salesData) => {
  const response = await axios.post(
    `${base_path}/Api/InvSale/Delete`,
    JSON.stringify(salesData)
  );

  return response.data;
};
// Create a new sales
export const addEditSales = async (salesData) => {
  const response = await axios.post(
    `${base_path}/Api/InvSale/SaveOrUpdate`,
    JSON.stringify(salesData)
  );

  return response;
};

//Get sales invoice by branch
export const getSalesByBranch = async (branch) => {
  const response = axios.get(
    `${base_path}/Api/InvSale/GetAll?globalBranchID=${branch?.guid}`
  );
  return response;
};
//Get sales invoice by branch

// earlier invoices of an item to a customer, newest first (Sales Invoice line note)
// excludeId: the invoice being edited, so it does not list itself
export const getLastSalesRates = async (branch, customerId, productId, excludeId) => {
  const response = await axios.get(`${base_path}/Api/InvSale/GetLastRates`, {
    params: {
      globalBranchID: branch?.guid,
      customerId,
      productId,
      ...(excludeId ? { excludeId } : {}),
    },
  });
  return response.data || [];
};
